fragment SavedFilterFragment on SavedFilter {
    id
    name
    htmlUrlPath
    createdTime
    count {
        value
        suffix
        prefix
        formatted
    }
    filterString
    entityType
}
